import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=369c0a8a&scoped=true&"
import script from "./ProductList.vue?vue&type=script&lang=js&"
export * from "./ProductList.vue?vue&type=script&lang=js&"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=369c0a8a&prod&lang=scss&scoped=true&"
import style1 from "./ProductList.vue?vue&type=style&index=1&id=369c0a8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369c0a8a",
  null
  
)

export default component.exports